import { Popconfirm, Tooltip } from "antd";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { ACTION_BTN_HOVER_CLR } from "@/Constants/common";
import { routingConstants } from "@/Constants/routingConstants";
import {
  deleteClientRoleListdata,
  fetchClientRoles,
  setClientRolesLoading,
  updatePagination,
} from "@/reducers/client_user/roleAccess";
import { fetchUserAccessCounts } from "@/reducers/client_user/userAccess";
import { TOOLTIPTEXT } from "@/utilities/CommonText";
import { showCommonToast, showErrorToast } from "@/utilities/utils";

import ActionIcons from "../../ActionIcons";

const Actions = () => {
  const { filters, isSelectedAll, selectedRoles, roles, pagination } =
    useSelector((state) => state.clientRoles);
  const dispatch = useDispatch();
  const [editLoading, setEditLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  // Returns the role object for a given encrypted role_id
  const getSelectedRoleObjects = () =>
    roles.filter((r) => selectedRoles.includes(r.role_id));

  const handleReloadTable = () => {
    dispatch(
      updatePagination({
        ...pagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(setClientRolesLoading(true));
    dispatch(fetchUserAccessCounts());
    dispatch(fetchClientRoles(filters));
  };
  return (
    <div className="RoleListActions_Wrapper tour-client-role-action">
      <div className="flex h-[40px] cursor-pointer overflow-hidden rounded-lg bg-grey [&>*:last-child]:border-r-0 [&>*]:grid [&>*]:w-[56px] [&>*]:min-w-[56px] [&>*]:place-items-center [&>*]:border-0 [&>*]:border-r [&>*]:border-r-[#E5E6E9] [&>*]:text-txtColor">
        <>
          <Tooltip title={TOOLTIPTEXT.edit}>
            <Link
              className={`group ${ACTION_BTN_HOVER_CLR.lightBlue}`}
              to={routingConstants.clientEditRole(selectedRoles[0] ?? 0)}
              onClick={(e) => {
                if (selectedRoles.length) {
                  if (selectedRoles.length !== 1) {
                    e.preventDefault();
                    showCommonToast("Please select one role");
                  } else {
                    const selectedObjs = getSelectedRoleObjects();
                    if (selectedObjs.some((r) => r.is_admin)) {
                      e.preventDefault();
                      showErrorToast(
                        "Action not allowed: You can't edit the Admin role",
                        { id: "edit-admin-role" },
                      );
                    } else if (
                      selectedObjs.some((r) => r.is_logged_user_role)
                    ) {
                      e.preventDefault();
                      showErrorToast(
                        "Action not allowed: You can't edit your own role",
                        { id: "edit-own-role" },
                      );
                    } else {
                      setEditLoading(true);
                      setTimeout(() => {
                        setEditLoading(false);
                      }, 2000);
                    }
                  }
                } else {
                  e.preventDefault();
                  showCommonToast("Please select one role", {
                    id: "no-role-selected",
                  });
                }
              }}
            >
              <ActionIcons isLoading={editLoading} type={"edit"} />
            </Link>
          </Tooltip>
          <Tooltip title={TOOLTIPTEXT.delete}>
            {selectedRoles.length > 0 ? (
              <Popconfirm
                description={
                  <>
                    <div className="max-w-[300px] p-4">
                      <p className="text-[16px] font-semibold leading-[normal] text-black">
                        Are you sure you want to delete <br />{" "}
                        {`${selectedRoles.length}`}{" "}
                        {selectedRoles.length === 1 ? "Role ?" : "Roles ?"}
                      </p>
                    </div>
                  </>
                }
                okButtonProps={{
                  className:
                    "bg-primary text-white border !border-primary hover:!bg-white hover:!text-primary",
                }}
                cancelButtonProps={{
                  className:
                    "bg-white text-primary border !border-primary hover:!bg-primary hover:!text-white",
                }}
                okText="Yes"
                cancelText="No"
                icon={null}
                onConfirm={() => {
                  const selectedObjs = getSelectedRoleObjects();
                  if (selectedObjs.some((r) => r.is_admin)) {
                    showErrorToast(
                      "Action not allowed: You can't delete the Admin role",
                      { id: "delete-admin-role" },
                    );
                    return;
                  }
                  if (selectedObjs.some((r) => r.is_logged_user_role)) {
                    showErrorToast(
                      "Action not allowed: You can't delete your own role",
                      { id: "delete-own-role" },
                    );
                    return;
                  }
                  let decrIds = [];
                  roles.map((item) => {
                    if (selectedRoles.includes(item.role_id)) {
                      decrIds.push(item.decr_role_id);
                    }
                  });
                  dispatch(
                    deleteClientRoleListdata({
                      role_id: decrIds.join(","),
                      callback: () => handleReloadTable(),
                      loading: deleteLoading,
                      setLoading: setDeleteLoading,
                      isSelectedAll: isSelectedAll,
                      ignoreIds: isSelectedAll
                        ? roles
                            .filter(
                              (ele) => !selectedRoles.includes(ele.role_id),
                            )
                            .map((ele) => ele.decr_role_id)
                            .join(",")
                        : {},
                    }),
                  );
                }}
              >
                <button className={`group ${ACTION_BTN_HOVER_CLR.red}`}>
                  <ActionIcons isLoading={deleteLoading} type={"delete"} />
                </button>
              </Popconfirm>
            ) : (
              <button
                className={`group ${ACTION_BTN_HOVER_CLR.red}`}
                onClick={() =>
                  showCommonToast("Please select one role", {
                    id: "no-role-selected",
                  })
                }
              >
                <ActionIcons isLoading={deleteLoading} type={"delete"} />
              </button>
            )}
          </Tooltip>
        </>
      </div>
    </div>
  );
};

export default Actions;
